import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';


@Component(
    {
    selector: 'cz-erl-popup',
    templateUrl: './cz-erl-popup.component.html',
    styleUrls: ['./cz-erl-popup.component.css'],
    standalone: false
})
export class ErlaubnisPopupComponent {

    public eventsSubject: Subject<any> = new Subject<any>();

    popupVisible: boolean;
    @Input() eId: number;
    @Input() label: string = 'Erlaubnis';
    @Input() optional: any;
    @Input() isErsdtAntrag: boolean = true;

    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCloseOk: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
        this.save = this.save.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    save() {
        this.eventsSubject.next('Save');
    }

    showPopup() {
        this.popupVisible = true;
    }

    closePopup() {
        this.eventsSubject.next('Close');
        this.onClose.emit(null);
        this.popupVisible = false;
    }

    onCloseOkEvent(event) {
        this.eventsSubject.next('Close');
        this.onCloseOk.emit(event);
        this.popupVisible = false;
    }
}
